import React from 'react';

import { OptionProps, components } from 'react-select';

import classes from 'components/DesignSystem/Select/components/OptionsWithExclude/OptionsWithExclude.module.scss';

export const OptionsWithExclude = <
    T extends { label: string; value: { name: string | number; isExclude: boolean; alias?: string | null } },
>(
    props: OptionProps<T>,
) => {
    const { value, label } = props.data;
    const { setValue, getValue } = props;
    const selectedOptions = getValue();

    const handleExclude = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (selectedOptions.length > 2) return;

        setValue(
            [
                ...selectedOptions,
                {
                    label: `Exclude:${props.data.label}`,
                    value: {
                        ...props.data.value,
                        isExclude: true,
                    },
                },
            ] as T[],
            'select-option',
        );
    };

    return (
        <>
            {!selectedOptions.find((item) => item.value.name === value.name) && (
                <components.Option {...props}>
                    <div className={classes.labelWithExcludeWrapper}>
                        {label}
                        <div className={classes.hoverBox}>
                            <div data-testid={'include-text'} className={classes.includeExcludeTextHover}>
                                Include
                            </div>
                            <div
                                data-testid={'exclude-text'}
                                className={classes.includeExcludeTextHover}
                                onClick={(e) => handleExclude(e)}
                            >
                                Exclude
                            </div>
                        </div>
                    </div>
                </components.Option>
            )}
        </>
    );
};
